// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__container__y037G {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 5rem;
}
.index-module__dropdown__selector__hQO9_ {
  width: 14vw;
  font-size: 18px;
  border: 2px solid var(--app-secondary-color);
  border-radius: 7px;
}
.index-module__user-profile__JbCWK {
  width: 100%;
  cursor: pointer;
  border-radius: 20px;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__gx-avatar-name__cpHvh {
  font-weight: 500;
  font-size: 17px;
  line-height: 100%;
  letter-spacing: -0.03em;
  cursor: pointer;
}
.index-module__user-type-container__G8Hsv {
  margin-right: 7rem !important;
}
.index-module__dropdown-container__RUneg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  margin-right: 20px !important;
}
.index-module__location-dropdown__dV0AC,
.index-module__client-dropdown__unv_B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.index-module__dropdown_label__djFWY {
  display: block;
  font-weight: bolder;
}
.index-module__plc-status-card__e5AVm {
  margin-right: 25px !important;
}
/* Media Queries */
@media only screen and (max-width: 768px) {
  .index-module__dropdown__selector__hQO9_ {
    width: 20vw !important;
    font-size: 14px;
    border-radius: 7px;
  }
  .index-module__options-label__mVRIv {
    font-size: 12px !important;
  }
  .index-module__dropdown_label__djFWY {
    display: none;
  }
  .index-module__gx-avatar-name__cpHvh {
    display: none;
  }
}
@media only screen and (min-width: 600px) and (max-width: 768px) {
  .index-module__user-profile__JbCWK {
    padding: 10px 20px;
  }
  .index-module__gx-avatar-name__cpHvh {
    font-size: 12px;
  }
  .index-module__user-type-container__G8Hsv {
    margin-right: 5rem !important;
  }
  .index-module__options-label__mVRIv,
  .index-module__dropdown_label__djFWY {
    display: none;
  }
}
@media only screen and (max-width: 600px) {
  .index-module__user-type-container__G8Hsv {
    margin-right: 2rem !important;
  }
  .index-module__user-profile__JbCWK {
    padding: 7px 10px;
  }
  .index-module__gx-avatar-name__cpHvh {
    font-size: 10px;
  }
  .index-module__options-label__mVRIv {
    font-size: 12px !important;
  }
  .index-module__dropdown_label__djFWY {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .index-module__dropdown__selector__hQO9_ {
    width: 11vw;
    font-size: 13px;
  }
  .index-module__dropdown_label__djFWY {
    display: none;
  }
}
@media only screen and (min-width: 1300px) and (max-width: 1370px) {
  .index-module__dropdown__selector__hQO9_ {
    width: 12vw;
    font-size: 16px;
  }
  .index-module__dropdown_label__djFWY {
    font-size: 16px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1300px) {
  .index-module__dropdown__selector__hQO9_ {
    width: 11vw;
    font-size: 16px;
  }
  .index-module__dropdown_label__djFWY {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/TopBar/UserProfile/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.container {\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 5rem;\n}\n.dropdown__selector {\n  width: 14vw;\n  font-size: 18px;\n  border: 2px solid var(--app-secondary-color);\n  border-radius: 7px;\n}\n.user-profile {\n  width: 100%;\n  cursor: pointer;\n  border-radius: 20px;\n  padding: 10px 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.gx-avatar-name {\n  font-weight: 500;\n  font-size: 17px;\n  line-height: 100%;\n  letter-spacing: -0.03em;\n  cursor: pointer;\n}\n.user-type-container {\n  margin-right: 7rem !important;\n}\n.dropdown-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1.5rem;\n  margin-right: 20px !important;\n}\n.location-dropdown,\n.client-dropdown {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.dropdown_label {\n  display: block;\n  font-weight: bolder;\n}\n.plc-status-card {\n  margin-right: 25px !important;\n}\n/* Media Queries */\n@media only screen and (max-width: 768px) {\n  .dropdown__selector {\n    width: 20vw !important;\n    font-size: 14px;\n    border-radius: 7px;\n  }\n  .options-label {\n    font-size: 12px !important;\n  }\n  .dropdown_label {\n    display: none;\n  }\n  .gx-avatar-name {\n    display: none;\n  }\n}\n@media only screen and (min-width: 600px) and (max-width: 768px) {\n  .user-profile {\n    padding: 10px 20px;\n  }\n  .gx-avatar-name {\n    font-size: 12px;\n  }\n  .user-type-container {\n    margin-right: 5rem !important;\n  }\n  .options-label,\n  .dropdown_label {\n    display: none;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .user-type-container {\n    margin-right: 2rem !important;\n  }\n  .user-profile {\n    padding: 7px 10px;\n  }\n  .gx-avatar-name {\n    font-size: 10px;\n  }\n  .options-label {\n    font-size: 12px !important;\n  }\n  .dropdown_label {\n    display: none;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  .dropdown__selector {\n    width: 11vw;\n    font-size: 13px;\n  }\n  .dropdown_label {\n    display: none;\n  }\n}\n@media only screen and (min-width: 1300px) and (max-width: 1370px) {\n  .dropdown__selector {\n    width: 12vw;\n    font-size: 16px;\n  }\n  .dropdown_label {\n    font-size: 16px;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1300px) {\n  .dropdown__selector {\n    width: 11vw;\n    font-size: 16px;\n  }\n  .dropdown_label {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container__y037G`,
	"dropdown__selector": `index-module__dropdown__selector__hQO9_`,
	"user-profile": `index-module__user-profile__JbCWK`,
	"gx-avatar-name": `index-module__gx-avatar-name__cpHvh`,
	"user-type-container": `index-module__user-type-container__G8Hsv`,
	"dropdown-container": `index-module__dropdown-container__RUneg`,
	"location-dropdown": `index-module__location-dropdown__dV0AC`,
	"client-dropdown": `index-module__client-dropdown__unv_B`,
	"dropdown_label": `index-module__dropdown_label__djFWY`,
	"plc-status-card": `index-module__plc-status-card__e5AVm`,
	"options-label": `index-module__options-label__mVRIv`
};
export default ___CSS_LOADER_EXPORT___;
